<template>
    <modal
        :active="active"
        @closed="$emit('closed', true)"
        title="Følgeseddel"
    >
        <table class="table is-fullwidth">
            <thead>
            <tr>
                <td></td>
                <td>Type</td>
                <td>Antal</td>
                <td>Fragt</td>
            </tr>
            </thead>
            <tr v-for="item in productLines" :key="item.id" @click="toggleIndex(item.id)" class="is-clickable">
                <td><input type="checkbox" :checked="isSelected(item.id)" /></td>
                <td>{{ item.type }}</td>
                <td>{{ item.count }}</td>
                <td>{{ item.no_shipping ? 'Nej' : 'Ja' }}</td>
            </tr>
        </table>

        <template v-slot:footer class="has-space-between">
            <div class="footer-spacer">
                <div>
                    <button class="button is-danger" @click="reset">Nulstil</button>
                    <button class="button is-default" @click="selectAll">Vælg alle</button>
                    <button class="button is-default" @click="$emit('closed')">Annuller</button>
                    <button class="button is-primary" @click="submit">Print</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from '@elems/modal'
import { FormField, InputCheckbox } from '@elems/form'
import cloneDeep from 'lodash/cloneDeep'

export default {
    components: {
        Modal,
        InputCheckbox,
        FormField,
    },
    props: {
        active: Boolean,
        project: Object,
    },

    data() {
        return {
            indexes: [],
        }
    },

    computed: {
        productLines() {
            if (!this.project.lines) {
                return
            }
            return cloneDeep(this.project.lines).filter(item => item.service_ref === null)
        }
    },

    methods: {
        isSelected(index) {
            return this.indexes.indexOf(index) === -1 ? 0 : 1
        },

        toggleIndex(index) {
            const idx = this.indexes.indexOf(index)
            if (idx === -1) {
                this.indexes.push(index)
            } else {
                this.indexes.splice(idx,1)
            }
        },

        reset() {
            this.indexes = [];
        },

        selectAll() {
            this.indexes = [];
            this.productLines.forEach(item => this.indexes.push(item.id))
        },

        submit() {
            if (this.indexes.length === 0) {
                return
            }

            window.open('/delivery-note/' + this.project.id + '?items=' + this.indexes.join(','))
            this.$emit('closed')
        }
    }
}
</script>
